import {
  GET_ADDRESS_DETAILS,
  GET_VIA_POINTS,
  EDIT_START_POINT,
  EDIT_END_POINT,
  EDIT_LANE,
  CREATE_VIA_POINT,
  EDIT_VIA_POINT,
  DELETE_VIA_POINT,
  CREATE_NEW_ADDRESS,
  EDIT_ADDRESS,
  CLEAR_FLAGS,
  CLEAR_VIA_POINTS_LIST,
  DELETE_POC,
  GET_ADDRESS_DETAILS_V4,
  SELECT_MAP_LOCATION,
  UPDATE_ADDRESS,
  CREATE_NEW_ADDRESS_V4,
  SUBMIT_NEW_ADDRESSES_V4,
  RESET_ADDRESS_CREATED,
  SELECT_MAP_LOCATION_RESET,
} from './actions';
import { REQUEST, SUCCESS } from 'utils/actionGenerator';
import _get from 'lodash/get';

const insertAddresses = (prevAddresses, targetAddress) => {
  let tempAddress = [];
  const index = 1;
  const reverseArray = prevAddresses.reverse();
  if (prevAddresses.length === 0) {
    tempAddress.push(targetAddress);
    return tempAddress;
  }
  if (prevAddresses.length === 1) {
    tempAddress.push(prevAddresses[0]);
    tempAddress.push(targetAddress);
    return tempAddress;
  }
  for (let i = 0; i < prevAddresses.length; i++) {
    if (i === index) {
      tempAddress.push(targetAddress);
    }
    tempAddress.push(reverseArray[i]);
  }

  return tempAddress.reverse();
};

const defaultState = {};

export default function (state = defaultState, action) {
  switch (action.type) {
    case GET_ADDRESS_DETAILS[SUCCESS]:
      return { ...state, addressDetails: action.response.data };
    case GET_ADDRESS_DETAILS_V4[SUCCESS]:
      return { ...state, addressDetailsV4: action.response };
    case CREATE_NEW_ADDRESS_V4[REQUEST]:
      return {
        ...state,
        addressDetailsV4: {
          ...state.addressDetailsV4,
          addresses: insertAddresses(state.addressDetailsV4.addresses, action.params),
        },
        addressCreated: true,
      };
    case UPDATE_ADDRESS[REQUEST]:
      return { ...state, addressEdited: false };
    case UPDATE_ADDRESS[SUCCESS]:
      return { ...state, addressEdited: true };
    case SUBMIT_NEW_ADDRESSES_V4[SUCCESS]:
      return { ...state, addressSubmited: true };
    case GET_VIA_POINTS[SUCCESS]:
      return { ...state, viaPointsList: action.response.data };
    case CLEAR_VIA_POINTS_LIST:
      return { ...state, viaPointsList: [] };
    case EDIT_START_POINT[REQUEST]:
      return { ...state, startPointEdited: false };
    case EDIT_START_POINT[SUCCESS]:
      return { ...state, startPointEdited: true };
    case EDIT_END_POINT[REQUEST]:
      return { ...state, endPointEdited: false };
    case EDIT_END_POINT[SUCCESS]:
      return { ...state, endPointEdited: true };
    case EDIT_LANE[REQUEST]:
      return { ...state, laneNameEdited: false };
    case EDIT_LANE[SUCCESS]:
      return { ...state, laneNameEdited: true };

    case CREATE_VIA_POINT[REQUEST]:
      return { ...state, viaPointCreated: false };
    case CREATE_VIA_POINT[SUCCESS]:
      return { ...state, viaPointCreated: true };

    case EDIT_VIA_POINT[REQUEST]:
      return { ...state, viaPointEdited: false };
    case EDIT_VIA_POINT[SUCCESS]:
      return { ...state, viaPointEdited: true };
    case DELETE_VIA_POINT[REQUEST]:
      return { ...state, viaPointDeleted: false };
    case DELETE_POC[REQUEST]:
      return { ...state, pocDeleted: false };
    case DELETE_POC[SUCCESS]:
      return { ...state, pocDeleted: true };
    case DELETE_VIA_POINT[SUCCESS]:
      return { ...state, viaPointDeleted: true };
    case SELECT_MAP_LOCATION[SUCCESS]:
      return { ...state, selectedLocationAddress: action.response.data.data[0] };
    case SELECT_MAP_LOCATION_RESET:
      return { ...state, selectedLocationAddress: {} };
    case CLEAR_FLAGS:
      return {
        ...state,
        startPointEdited: false,
        endPointEdited: false,
        viaPointCreated: false,
        viaPointEdited: false,
        viaPointDeleted: false,
        addressCreated: false,
        addressEdited: false,
        pocDeleted: false,
        laneNameEdited: false,
        addressSubmited: false,
      };
    case RESET_ADDRESS_CREATED:
      return { ...state, addressCreated: false };
    case CREATE_NEW_ADDRESS[REQUEST]:
      return { ...state, addressCreated: false };
    case CREATE_NEW_ADDRESS[SUCCESS]:
      return { ...state, addressCreated: true };

    case EDIT_ADDRESS[REQUEST]:
      return { ...state, addressEdited: false };
    case EDIT_ADDRESS[SUCCESS]:
      return { ...state, addressEdited: true };
    default:
      return state;
  }
}

export const getAddressDetails = (state) => _get(state, 'placement.tripTab.addressDetails', {});
export const getAddressDetailsV4 = (state) => _get(state, 'placement.tripTab.addressDetailsV4', {});
export const getViaPoints = (state) => _get(state, 'placement.tripTab.viaPointsList', {});
export const getStartPointEditFlag = (state) => _get(state, 'placement.tripTab.startPointEdited', false);
export const getLaneNameEditFlag = (state) => _get(state, 'placement.tripTab.laneNameEdited', false);
export const getEndPointEditFlag = (state) => _get(state, 'placement.tripTab.endPointEdited', false);
export const getCreateViaPointFlag = (state) => _get(state, 'placement.tripTab.viaPointCreated', false);
export const getEditViaPointFlag = (state) => _get(state, 'placement.tripTab.viaPointEdited', false);
export const getDeleteViaPointFlag = (state) => _get(state, 'placement.tripTab.viaPointDeleted', false);
export const getCreateAddressFlag = (state) => _get(state, 'placement.tripTab.addressCreated', false);
export const getSubmitAddressFlag = (state) => _get(state, 'placement.tripTab.addressSubmited', false);
export const getEditAddressFlag = (state) => _get(state, 'placement.tripTab.addressEdited', false);
export const getDeletePocFlag = (state) => _get(state, 'placement.tripTab.pocDeleted', false);
export const getSelectedLocationData = (state) => _get(state, 'placement.tripTab.selectedLocationAddress', {});
